/*
 * @Description: 录单设置
 * @Author: liuzhonghui
 * @Date: 2025-05-14 17:52:27
 * @LastEditTime: 2025-05-14 17:52:27
 * @LastEditors: liuzhonghui
 */
// 引入api请求方法
import { aiCorporationConfigInfoList } from '@/api/waybillAI';

const state = {
  // 筛选项-
  parameters: [],
  // tabs筛选项
  isSpecialTabs: false,
  // 页码
  postParams: {
    page: 1,
    size: 20,
  },
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '上游系统',
        prop: 'sourceTypeName',
        width: 60,
        checked: 1,
        sortable: true,
      },
      {
        label: '导入运单是否过滤自营车辆',
        prop: 'businessName',
        width: 80,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-operation1',
      },
      {
        label: '自定义运单号',
        width: 80,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-operation',
      },
      {
        label: '货物重量(吨)',
        width: 120,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-operation2',
      },
    ],
  },
};

// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getList: async context => {
    const params = {};
    params.businessId = localStorage.getItem('aicurrentData') || localStorage.getItem('aiBid');
    const { data } = await aiCorporationConfigInfoList(
      Object.assign({}, params, context.state.postParams),
    );
    data.list = data.records;
    context.commit('updateState', {
      key: 'listData',
      value: Object.assign({}, context.state.listData, data),
    });
    console.log('data', data.list);
    return data.list;
  },
};
// mutations
const mutations = {
  // 重置所有状态
  initFilter(state) {
    state.postParams = {
      page: 1,
      size: 20,
    };
  },
  // 更新state数据
  updateState(state, { key, value }) {
    state[key] = value;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  // 根据index更新value
  updateValueFromIndex(state, payload) {
    state.parameters[payload.index].value = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
